module.exports = __webpack_public_path__ + "static/media/M010-account.20baa20e.svg";